<script>
    import LazyAppearingComponent from "@app/components/LazyAppearingComponent.svelte";
    import { changeDictionaryWidgetActive } from "../ChangeDictionary.store";
    import ChangeDictionaryWidget from "./ChangeDictionaryWidget.svelte";
</script>

<LazyAppearingComponent
    show={$changeDictionaryWidgetActive}
    class="fixed inset-0 bg-white transition-all duration-300 ease-in-out w-full h-full z-50"
    hiddenClass="dir-aware-left-100p"
    dataElement="change-dictionary-widget"
>
    <ChangeDictionaryWidget />
</LazyAppearingComponent>
